import { LanguageRounded as LanguageRoundedIcon } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import LanguageMenu from '../LanguageMenu/LanguageMenu.jsx'

const LanguageToggle = () => {
  const { i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        aria-label={i18n.language === 'it' ? 'cambia lingua' : 'switch language'}
        color="primary"
        onClick={handleClick}
      >
        <LanguageRoundedIcon fontSize="small" />
      </IconButton>
      <LanguageMenu
        handleClose={handleClose}
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        open={open}
      />
    </>
  )
}

export default LanguageToggle
